import { format } from 'date-fns';

import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/Challenges-report',
};

export const getColumns = () => [
  {
    id: 'visitTime',
    label: 'Date/Time',
    customValue: (val) => format(new Date(val.visitTime), 'dd MMMM yyyy pp'),
    align: 'left',
    nameForSort: 'visit_time',
  },
  { id: 'challengeName', label: 'Challenge Name', align: 'center', nameForSort: 'challenge_name' },
  { id: 'facilityName', label: 'Facility Name', align: 'center', nameForSort: 'facility_name' },
  { id: 'className', label: 'Class', align: 'center', nameForSort: 'class_name' },
  { id: 'phoneNumber', label: 'Phone Number', align: 'center', nameForSort: 'class_name' },
  { id: 'userName', label: 'User Name', align: 'center', nameForSort: 'user_name' },
  { id: 'userSex', label: 'Gender', align: 'center', nameForSort: 'user_sex' },
  { id: 'userAge', label: 'Age', align: 'center', nameForSort: 'user_age' },
];

export const getFilters = ({ searchByName, challengeName, region, facilityName, dateRange, options }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Search by User name...',
    action: searchByName.change,
  },
  {
    id: 'dateRange',
    variant: 'dateTime',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
  {
    id: 'challenge',
    type: 'select',
    label: 'Challenge ',
    value: challengeName.value,
    action: challengeName.change,
    items: options?.challenges?.length ? ['all', ...options.challenges] : ['all'],
  },
  {
    id: 'facility',
    type: 'select',
    label: 'Facility',
    value: facilityName.value,
    action: facilityName.change,
    items: options?.facilities?.length ? ['all', ...options.facilities] : ['all'],
  },
  {
    id: 'region',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
];
